
import { Component, Mixins } from "vue-property-decorator";
import { DragKinds } from "./../DragKinds";
import { default as DragHandlesMixin } from "./DragHandlesMixin.vue";

@Component({
})
export default class RectangleDragHandlesMixin extends Mixins(DragHandlesMixin) {
  dragTopLeft: DragKinds = DragKinds.TopLeft;
  dragTopRight: DragKinds = DragKinds.TopRight;
  dragBottomLeft: DragKinds = DragKinds.BottomLeft;
  dragBottomRight: DragKinds = DragKinds.BottomRight;
  dragLeft: DragKinds = DragKinds.Left;
  dragTop: DragKinds = DragKinds.Top;
  dragRight: DragKinds = DragKinds.Right;
  dragBottom: DragKinds = DragKinds.Bottom;
}
